/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if(window.innerWidth < 800){
  $('.make-slider .quick-links').slick({
    infinite: false,
      slidesToShow: 2,
      arrows: false,
      dots: true,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 500,
              settings: {
                  slidesToShow: 1
              }
          }
      ]
  });
}

var swiper = new Swiper(".featured-swiper-slider", {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      centeredSlides: true,
      slidesPerView: 1,
    },
    461: {
      slidesPerView: "auto",
      centeredSlides: false,
    }
  }
});

var swiper = new Swiper(".mega-menu_products", {
  slidesPerView: "auto",
  spaceBetween: 10,
  autoplay: {
    delay: 3000, // change delay as needed (in milliseconds)
    disableOnInteraction: false,
  },
  // Hide navigation arrows
  navigation: false,
});


$('.custom-design-body .product-list').flickity({
  watchCSS: true,
  pageDots: false,
  prevNextButtons: true,
  contain: true,
  resize: false,
  groupCells: true,
  cellAlign: "left",
  draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
});

// $(document).on("click",".header__cart-toggle",function() {
//   $('body').addClass('overflow_hidden');
// });
// $(document).on("click",".mini-cart__header-close",function() {
//   $('body').removeClass('overflow_hidden');
//   $('form#mini-cart').attr('aria-hidden', 'true');
// });

$(document).on("click",".mega-menu__title",function() {
  $(this).parent('.mega-menu__column').find('.mega-menu__linklist').slideToggle();
});